<template>
  <div class="relative bg-white pt-16 pb-16">
    <div class="px-4 md:px-10 mx-auto w-full">
      <div class="flex flex-wrap mt-6">
        <div class="w-full px-4">
          <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
            <div class="rounded-t mb-0 px-6 py-3 border-0">
              <div class="flex flex-wrap items-center">
                <div class="relative w-full px-4 max-w-full flex-grow flex-1">
                  <h3 class="font-semibold text-base text-blueGray-700">用户列表</h3>
                </div>
              </div>
            </div>

            <div class="block w-full px-6 pb-6">
              <el-form ref="ruleForm" :inline="true" :model="filters" class="demo-form-inline">
                <el-form-item label="用户ID" prop="user_id">
                  <el-input v-model="filters.user_id" placeholder="请输入用户ID" clearable />
                </el-form-item>

                <el-form-item label="注册日期">
                  <el-date-picker
                    v-model="filters.registration"
                    type="daterange"
                    range-separator="~"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :shortcuts="dateShortcuts"
                    clearable
                  />
                </el-form-item>

                <el-form-item label="进行中">
                  <el-input-number
                    v-model="filters.start_task_min"
                    class="range-number"
                    controls-position="right"
                    :min="-1"
                  />
                  <span class="range-separator">-</span>
                  <el-input-number
                    v-model="filters.start_task_max"
                    class="range-number"
                    controls-position="right"
                    :min="-1"
                  />
                </el-form-item>

                <el-form-item label="活动总数">
                  <el-input-number
                    v-model="filters.all_task_min"
                    class="range-number"
                    controls-position="right"
                    :min="-1"
                  />
                  <span class="range-separator">-</span>
                  <el-input-number
                    v-model="filters.all_task_max"
                    class="range-number"
                    controls-position="right"
                    :min="-1"
                  />
                </el-form-item>

                <el-form-item label="使用时间">
                  <el-date-picker
                    v-model="filters.usage_time"
                    type="daterange"
                    range-separator="~"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :shortcuts="dateShortcuts"
                    clearable
                  />
                </el-form-item>

                <el-form-item label="付费状态">
                  <el-select v-model="filters.payStatus" placeholder="请选择付费状态">
                    <el-option label="全部" :value="-1" />
                    <el-option label="未付费" :value="0" />
                    <el-option label="付费中" :value="1" />
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="queryData()">查询</el-button>
                  <el-button @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>

              <div class="block w-full overflow-x-auto">
                <el-table
                  v-loading="loading"
                  :data="users"
                  border
                  stripe
                  highlight-current-row
                  style="width: 100%; min-width: 1280px;"
                  @sort-change="handleSortChange"
                >
                  <el-table-column fixed label="用户ID" width="340">
                    <template #default="scope">
                      <div class="column-item">
                        <span>user_id：</span>
                        <span>{{ scope.row.user_id || "-" }}</span>
                      </div>
                      <div class="column-item">
                        <span>uid：</span>
                        <span>{{ scope.row.uid || "-" }}</span>
                      </div>
                      <div class="column-item">
                        <span>unionid：</span>
                        <span>{{ scope.row.unionid || "-" }}</span>
                      </div>
                      <div class="column-item">
                        <span>mobile：</span>
                        <span>{{ scope.row.mobile || "-" }}</span>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column fixed prop="create_time" label="注册/最近活跃" width="180" sortable="custom">
                    <template #default="scope">
                      <div>{{ scope.row.create_time || "-" }}</div>
                      <div>{{ scope.row.last_use_time || "-" }}</div>
                    </template>
                  </el-table-column>

                  <el-table-column fixed prop="start_task_count" label="进行中/总数" width="130" sortable="custom">
                    <template #default="scope">
                      <span>{{ scope.row.start_task_count }} / {{ scope.row.all_task_count }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column fixed label="付费状态" width="180">
                    <template #default="scope">
                      <el-tag class="pay-status-tag" :type="scope.row.is_vip ? 'warning' : 'info'" size="small">
                        {{ scope.row.pay_status }}
                      </el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column fixed label="封禁状态" width="100">
                    <template #default="scope">
                      <span v-if="scope.row.is_banned" class="text-red-500">
                        已封禁，原因：{{ scope.row.ban_reason || "-" }}
                      </span>
                      <span v-else>--</span>
                    </template>
                  </el-table-column>

                  <el-table-column fixed label="现场抽奖体验权益" min-width="190">
                    <template #default="scope">
                      <div>参与形式: {{ scope.row.join_by_h5 === 0 ? "小程序" : "H5" }}</div>
                      <div>{{ scope.row.trial_str || "-" }}</div>
                    </template>
                  </el-table-column>

                  <el-table-column label="操作" fixed="right" width="230">
                    <template #default="scope">
                      <el-button
                        v-for="action in getRowActions(scope.row)"
                        :key="action.key"
                        :type="action.type"
                        size="small"
                        link
                        @click="handleRowAction(action.key, scope.row)"
                      >
                        {{ action.label }}
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <el-pagination
                :current-page="currentPage"
                :page-size="pageSize"
                class="flex justify-end mt-4"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalRecords"
                :page-sizes="[20, 50, 100]"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      v-model="liveTrialDialogVisible"
      title="现场抽奖体验权限设置"
      width="500px"
      :close-on-click-modal="false"
      @closed="resetLiveTrialForm"
    >
      <el-form :model="liveTrialForm" label-width="170px" size="small">
        <div class="dialog-identity">
          <div>{{ liveTrialForm.unionid || "-" }}</div>
          <div>{{ liveTrialForm.uid || "-" }}</div>
        </div>
        <el-form-item label="试用到期时间(天)">
          <el-input-number v-model="liveTrialForm.t_expire" :min="0" controls-position="right" />
        </el-form-item>
        <el-form-item label="允许内定">
          <el-switch v-model="liveTrialForm.internal_rule" />
        </el-form-item>
        <el-form-item label="奖项数量">
          <el-input-number v-model="liveTrialForm.max_prizes" :min="-1" controls-position="right" />
          <span class="form-tip">默认3，-1不限制</span>
        </el-form-item>
        <el-form-item label="单奖项奖品数量">
          <el-input-number v-model="liveTrialForm.max_prize_count" :min="-1" controls-position="right" />
          <span class="form-tip">默认5，-1不限制</span>
        </el-form-item>
        <el-form-item label="试用人数">
          <el-input-number v-model="liveTrialForm.max_trial_count" :min="0" controls-position="right" />
          <span class="form-tip">默认8</span>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="liveTrialDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="savingLiveTrial" @click="resetLiveTrialRights">保存</el-button>
      </template>
    </el-dialog>

    <el-dialog v-model="transferDialogVisible" title="转移VIP权益" width="420px" :close-on-click-modal="false">
      <el-form label-width="130px">
        <el-form-item label="目标用户unionid">
          <el-input v-model="transferTargetUnionid" placeholder="请输入目标用户unionid" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="transferDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="transferring" @click="handleTransferConfirm">确认转移</el-button>
      </template>
    </el-dialog>

    <el-dialog v-model="banDialogVisible" :title="banDialogTitle" width="420px" :close-on-click-modal="false">
      <el-form ref="banFormRef" :model="banForm" :rules="banRules" label-width="100px">
        <el-form-item label="用户ID">
          <span>{{ banForm.user_id }}</span>
        </el-form-item>
        <el-form-item v-if="banAction === 'ban'" label="封禁理由" prop="reason">
          <el-input v-model="banForm.reason" type="textarea" placeholder="请输入封禁理由" :rows="3" />
        </el-form-item>
        <el-form-item v-else label="确认操作">
          <span>确定要解除该用户的封禁状态吗？</span>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="closeBanDialog">取消</el-button>
        <el-button type="primary" :loading="banning" @click="handleBanConfirm">{{ banConfirmText }}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { isTestAdminApiEnabled, luckdrawApi } from "@/api/luckdraw.js";
import {
  buildUserSearchRequest,
  getDefaultUserSearchFilters,
  getUserBanRequest,
  getUserRowActions,
  normalizeUserListItem,
  validateUserSearchFilters,
} from "./usersPresenter.js";

function createShortcutRange(days) {
  const end = new Date(new Date().toLocaleDateString());
  end.setHours(23, 59, 59, 999);
  const start = new Date(new Date().toLocaleDateString());
  start.setDate(start.getDate() - days);
  return [start, end];
}

function getDefaultLiveTrialForm() {
  return {
    unionid: "",
    uid: "",
    t_expire: 1,
    max_trial_count: 8,
    internal_rule: false,
    max_prizes: 3,
    max_prize_count: 5,
  };
}

export default {
  name: "Users",
  data() {
    return {
      users: [],
      filters: getDefaultUserSearchFilters(),
      currentPage: 1,
      pageSize: 20,
      totalRecords: 0,
      loading: false,
      currentSort: null,
      liveTrialDialogVisible: false,
      liveTrialSourceRow: null,
      savingLiveTrial: false,
      liveTrialForm: getDefaultLiveTrialForm(),
      transferDialogVisible: false,
      transferTargetUnionid: "",
      transferSourceRow: null,
      transferring: false,
      banDialogVisible: false,
      banAction: "ban",
      banForm: {
        uid: "",
        user_id: "",
        reason: "",
      },
      banRules: {
        reason: [{ required: true, message: "请输入封禁理由", trigger: "blur" }],
      },
      banning: false,
      dateShortcuts: [
        {
          text: "最近一周",
          value: () => createShortcutRange(7),
        },
        {
          text: "最近一个月",
          value: () => createShortcutRange(30),
        },
        {
          text: "最近三个月",
          value: () => createShortcutRange(90),
        },
      ],
    };
  },
  computed: {
    banDialogTitle() {
      return this.banAction === "ban" ? "封禁用户" : "解封用户";
    },
    banConfirmText() {
      return this.banAction === "ban" ? "确认封禁" : "确认解封";
    },
  },
  mounted() {
    this.queryData();
  },
  methods: {
    async queryData(sort = this.currentSort) {
      const validationMessage = validateUserSearchFilters(this.filters);
      if (validationMessage) {
        this.$message.error(validationMessage);
        return;
      }

      const params = buildUserSearchRequest(
        this.filters,
        { page: this.currentPage, pageSize: this.pageSize },
        sort
      );

      this.loading = true;
      try {
        const result = await luckdrawApi.searchUsers(params);
        if (result.sta === 0 && result.data) {
          const items = result.data.items || result.data.list || [];
          this.users = items.map(normalizeUserListItem);
          this.totalRecords = result.data.count || result.data.total || 0;
        } else {
          throw new Error(result.msg || "获取用户列表失败");
        }
      } catch (error) {
        this.$message.error(error.message || "请求数据失败!");
      } finally {
        this.loading = false;
      }
    },
    onReset() {
      this.filters = getDefaultUserSearchFilters();
      this.currentPage = 1;
      this.currentSort = null;
      this.queryData(null);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.queryData();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.queryData();
    },
    handleSortChange(sort) {
      this.currentSort = sort && sort.prop && sort.order ? sort : null;
      this.queryData(this.currentSort);
    },
    getRowActions(user) {
      return getUserRowActions(user);
    },
    handleRowAction(action, user) {
      const handlers = {
        background: this.toBackground,
        authority: this.toAuthority,
        liveTrial: this.showLiveTrialDialog,
        transfer: this.showTransferDialog,
        ban: this.showBanDialog,
        unban: this.showUnbanDialog,
      };
      handlers[action] && handlers[action](user);
    },
    async toBackground(user) {
      try {
        const result = await luckdrawApi.getToken({ uid: user.uid || user.id });
        if (result.sta === 0 && result.data && result.data.token) {
          const baseUrl = isTestAdminApiEnabled()
            ? "https://test-lotto.weiyoubot.cn/dashboard?token="
            : "https://52choujiang.cn/dashboard?token=";
          window.open(`${baseUrl}${result.data.token}&gm=true`);
        } else {
          throw new Error(result.msg || "获取后台 token 失败");
        }
      } catch (error) {
        this.$message.error(error.message || "请求数据失败!");
      }
    },
    toAuthority(user) {
      this.$router.push(`/admin/customers/authority/${user.uid || user.id}`);
    },
    showLiveTrialDialog(row) {
      const setting = row.live_trial_setting || {};
      this.liveTrialSourceRow = row;
      this.liveTrialForm = {
        unionid: row.unionid,
        uid: row.uid || row.id,
        max_prize_count: setting.max_prize_count || 5,
        max_prizes: setting.max_prizes || 3,
        internal_rule: setting.internal_rule === 1 || setting.internal_rule === true,
        max_trial_count: setting.max_trial_count || 8,
        t_expire: 1,
      };
      this.liveTrialDialogVisible = true;
    },
    resetLiveTrialForm() {
      this.liveTrialSourceRow = null;
      this.liveTrialForm = getDefaultLiveTrialForm();
    },
    async resetLiveTrialRights() {
      this.savingLiveTrial = true;
      try {
        const payload = {
          ...this.liveTrialForm,
          internal_rule: this.liveTrialForm.internal_rule ? 1 : 0,
        };
        const result = await luckdrawApi.resetLiveTrialLimit(payload);
        if (result.sta === 0) {
          if (this.liveTrialSourceRow && result.data) {
            this.liveTrialSourceRow.trial_str = result.data.trial_str || this.liveTrialSourceRow.trial_str;
            this.liveTrialSourceRow.trial_status = this.liveTrialSourceRow.trial_str;
          }
          this.$message.success("操作成功!");
          this.liveTrialDialogVisible = false;
        } else {
          throw new Error(result.msg || "操作失败");
        }
      } catch (error) {
        this.$message.error(error.message || "操作失败");
      } finally {
        this.savingLiveTrial = false;
      }
    },
    showTransferDialog(row) {
      this.transferSourceRow = row;
      this.transferTargetUnionid = "";
      this.transferDialogVisible = true;
    },
    async handleTransferConfirm() {
      if (!this.transferTargetUnionid) {
        this.$message.error("请输入目标用户unionid");
        return;
      }

      this.transferring = true;
      try {
        const result = await luckdrawApi.transferVipRights({
          from_unionid: this.transferSourceRow.unionid,
          to_unionid: this.transferTargetUnionid,
        });
        if (result.sta === 0) {
          this.$message.success("转移成功");
          this.transferDialogVisible = false;
          this.queryData();
        } else {
          throw new Error(result.msg || "转移失败");
        }
      } catch (error) {
        this.$message.error(error.message || "请求失败");
      } finally {
        this.transferring = false;
      }
    },
    showBanDialog(row) {
      this.banAction = "ban";
      this.banForm = {
        uid: row.uid || row.id,
        user_id: row.user_id,
        reason: "",
      };
      this.banDialogVisible = true;
    },
    showUnbanDialog(row) {
      this.banAction = "unban";
      this.banForm = {
        uid: row.uid || row.id,
        user_id: row.user_id,
        reason: "",
      };
      this.banDialogVisible = true;
    },
    closeBanDialog() {
      this.banDialogVisible = false;
      this.banForm = {
        uid: "",
        user_id: "",
        reason: "",
      };
      this.$refs.banFormRef && this.$refs.banFormRef.resetFields();
    },
    async handleBanConfirm() {
      if (this.banAction === "ban") {
        const valid = await this.$refs.banFormRef.validate().catch(() => false);
        if (!valid) return;
      }

      this.banning = true;
      try {
        const request = getUserBanRequest(
          { id: this.banForm.uid },
          this.banAction,
          this.banForm.reason
        );
        const result = await luckdrawApi.banUser(request.body);
        if (result.sta === 0) {
          this.$message.success(this.banAction === "ban" ? "封禁成功" : "解封成功");
          this.closeBanDialog();
          this.queryData();
        } else {
          throw new Error(result.msg || "操作失败");
        }
      } catch (error) {
        this.$message.error(error.message || "请求失败");
      } finally {
        this.banning = false;
      }
    },
  },
};
</script>

<style scoped>
.range-number {
  width: 130px;
}

.range-separator {
  display: inline-block;
  margin: 0 8px;
  color: #6b7280;
}

.column-item {
  line-height: 1.7;
  word-break: break-all;
}

.pay-status-tag {
  max-width: 100%;
  height: auto;
  min-height: 20px;
  padding-top: 3px;
  padding-bottom: 3px;
  line-height: 1.4;
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: left;
}

.dialog-identity {
  margin-bottom: 16px;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  color: #4b5563;
  background: #f9fafb;
  word-break: break-all;
}

.form-tip {
  margin-left: 8px;
  color: #909399;
  font-size: 12px;
}
</style>
